export var ServiceCostType = /*#__PURE__*/ function(ServiceCostType) {
    ServiceCostType["Fixed"] = "fixed";
    ServiceCostType["Variable"] = "variable";
    ServiceCostType["Range"] = "range";
    return ServiceCostType;
}({});
